module.exports = __webpack_public_path__ + "img/25.09761495.svg";